export {
  VerticalPageHeaderSection,
  type VerticalPageHeaderSectionProps,
} from "./VerticalPageHeaderSection";
